<template>
  <div class="ac-undo" role="status" aria-live="polite" data-test="ac-undo-bar">
    <AcIcon name="check-check" :size="16" />
    <span class="ac-undo-text">{{ text }}</span>
    <button type="button" class="ac-undo-btn" data-test="ac-undo" @click="$emit('undo')">Undo</button>
  </div>
</template>

<script>
import AcIcon from './AcIcon.vue';

// "Cleared 3 alerts · Undo" — shown for a few seconds after any clear so nobody loses a card by accident.
export default {
  name: 'ActionCenterUndoBar',
  components: { AcIcon },
  props: {
    text: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.ac-undo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-top: 1px solid var(--ac-border);
  background: var(--ac-neutral-950);
  color: #fff;
  flex: none;
}

.ac-undo-text {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
}

.ac-undo-btn {
  border: 0;
  background: transparent;
  padding: 6px 2px;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  color: var(--ac-iris-300);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid var(--ac-iris-300);
    outline-offset: 2px;
    border-radius: 4px;
  }
}

@media (max-width: 767.98px) {
  .ac-undo {
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  }

  .ac-undo-btn {
    min-height: 44px;
    padding: 0 12px;
  }
}
</style>
